module.exports = __webpack_public_path__ + "img/maxwell-cat-world.3acc0d7d.png";